import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import PageSEO from "../../components/feature/PageSEO";
import HeroSection from "./components/HeroSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import ServicesPreview from "./components/ServicesPreview";
import TestimonialsSection from "./components/TestimonialsSection";
import ProcessSection from "./components/ProcessSection";
import PortfolioPreview from "./components/PortfolioPreview";
import CTASection from "./components/CTASection";

const siteUrl = (import.meta.env.VITE_SITE_URL ?? '').replace(/\/$/, '');

const homeSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Small Business Websites",
    "url": siteUrl || "https://example.com",
    "description": "Affordable, effective small business websites built to get you more leads and rank higher on Google.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${siteUrl || "https://example.com"}/?s={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "PixelCraft Agency",
    "url": siteUrl || "https://example.com",
    "logo": {
      "@type": "ImageObject",
      "url": "https://public.readdy.ai/ai/img_res/7a27f79f-61a9-4968-a678-e038698c6bd9.png"
    },
    "description": "Professional website design for small businesses, local trades, and startups. Affordable web design starting from £149.",
    "areaServed": {
      "@type": "Country",
      "name": "United Kingdom"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+44-7700-900123",
      "contactType": "customer service",
      "email": "hello@pixelcraft.agency",
      "availableLanguage": "English"
    },
    "sameAs": []
  },
  {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "PixelCraft Agency",
    "description": "Affordable small business websites and SEO services. Professional website design for small businesses starting from just £149.",
    "url": siteUrl || "https://example.com",
    "telephone": "+44-7700-900123",
    "email": "hello@pixelcraft.agency",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GB"
    },
    "priceRange": "££",
    "openingHours": "Mo-Fr 09:00-17:00",
    "image": "https://public.readdy.ai/ai/img_res/7a27f79f-61a9-4968-a678-e038698c6bd9.png",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Web Design Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Small Business Website",
            "description": "Complete website up to 5 pages"
          },
          "price": "149.00",
          "priceCurrency": "GBP"
        }
      ]
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Small Business Websites | Affordable Web Design for Small Businesses",
    "description": "Affordable, effective small business websites built to get you more leads and rank higher on Google. Professional website design for small businesses, local trades, and startups.",
    "url": siteUrl || "https://example.com",
    "inLanguage": "en-GB",
    "isPartOf": {
      "@type": "WebSite",
      "name": "PixelCraft Agency",
      "url": siteUrl || "https://example.com"
    },
    "about": {
      "@type": "Thing",
      "name": "Small Business Web Design"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": siteUrl || "https://example.com"
        }
      ]
    }
  }
];

export default function Home() {
  return (
    <main>
      <PageSEO
        title="Small Business Websites | Affordable Web Design for Small Businesses"
        description="Affordable, effective small business websites built to get you more leads and rank higher on Google. Professional website design for small businesses, local trades, and startups. Starting from just £149."
        canonical="/"
        schema={homeSchemas}
      />
      <Navbar />
      <HeroSection />
      <ProblemSection />
      <SolutionSection />
      <ServicesPreview />
      <TestimonialsSection />
      <ProcessSection />
      <PortfolioPreview />
      <CTASection />
      <Footer />
    </main>
  );
}
